import React from 'react'
import classNames from 'classnames'
import { twMerge} from 'tailwind-merge'

export const MenuButton = React.forwardRef((props, ref) => {
  const { active, children, className, state = 'primary'  } = props

  const stateClassNames = {
    primary: '',
    negative: 'text-negative font-medium',
  }[state] ?? ''

  return (
    <button
      ref={ref}
      {...props}
      className={classNames(twMerge(
        active ? 'bg-gray-100' : '',
        props.disabled ? 'opacity-50 cursor-not-allowed' : '',
        'block px-4 py-2 text-sm text-gray-700 w-full text-left',
        stateClassNames,
        className,
      ))}
    >
      { children }
    </button>
  )
})

export default MenuButton
